export default __webpack_public_path__ + "static/3-083822143b75be8305d97c034661cf58.png";